import { isNavigatorOnline } from '../../Utils/networking/networkHelpers'

type ImageState = {
  status: 'IDLE' | 'PENDING' | 'LOADING' | 'LOADED' | 'ERROR' | 'OFFLINE'
  resolvedImageUrl: string | null
  isOnline: boolean
  currentSrc: string | null
}

type ImageAction =
  | { type: 'RESET'; payload: { src: string; isOnline: boolean } }
  | { type: 'INTERSECTING' }
  | { type: 'LOAD_INITIATED' }
  | { type: 'LOAD_SUCCESS'; payload: string }
  | { type: 'LOAD_FAILURE' }
  | { type: 'SET_ONLINE'; payload: boolean }

export const initialState: ImageState = {
  status: 'IDLE',
  resolvedImageUrl: null,
  isOnline: isNavigatorOnline(),
  currentSrc: null,
}

export const imageReducer = (state: ImageState, action: ImageAction): ImageState => {
  switch (action.type) {
    case 'RESET': {
      if (state.resolvedImageUrl) {
        URL.revokeObjectURL(state.resolvedImageUrl)
      }
      return {
        ...initialState,
        isOnline: action.payload.isOnline,
        currentSrc: action.payload.src,
        status: 'IDLE',
      }
    }
    case 'INTERSECTING': {
      if (state.status === 'IDLE' && state.isOnline && state.currentSrc) {
        return { ...state, status: 'PENDING' }
      }
      if (
        (state.status === 'IDLE' || state.status === 'ERROR') &&
        !state.isOnline &&
        state.currentSrc
      ) {
        return { ...state, status: 'OFFLINE' }
      }
      return state
    }
    case 'LOAD_INITIATED': {
      if (
        state.status === 'PENDING' ||
        state.status === 'ERROR' ||
        state.status === 'OFFLINE'
      ) {
        return { ...state, status: 'LOADING' }
      }
      return state
    }
    case 'LOAD_SUCCESS': {
      if (state.resolvedImageUrl) {
        URL.revokeObjectURL(state.resolvedImageUrl)
      }
      return {
        ...state,
        status: 'LOADED',
        resolvedImageUrl: action.payload,
      }
    }
    case 'LOAD_FAILURE': {
      return { ...state, status: 'ERROR' }
    }
    case 'SET_ONLINE': {
      if (!action.payload) {
        return {
          ...state,
          isOnline: false,
          status:
            state.status === 'LOADING'
              ? 'ERROR'
              : state.status === 'PENDING'
              ? 'OFFLINE'
              : state.status,
        }
      } else {
        const newStatus = state.status === 'OFFLINE' ? 'PENDING' : state.status
        return { ...state, isOnline: true, status: newStatus }
      }
    }
    default:
      return state
  }
}
